<template>
    <div class="well-graphical-events-bar">
        <div
            v-for="(mk, index) in morphokinetics"
            :key="index"
            class="graphical-event-tick"
            :class="$uiUtils.getColoredRangeMetricColorClass(mk)"
            :style="`left: ${leftValues[index]}%; width: ${widthValues[index]}%;`"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'WellGraphicalEventsBar',
    props: {
        well: {
            type: Object,
            required: true
        },
        slideIncubationLength: {
            type: Number,
            required: true
        }
    },
    computed: {
        morphokinetics() {
            return this.well.inferenceData.morphokinetics
        },
        leftValues() {
            return this.morphokinetics.map((mk, index) => {
                if (index === 0) return 0

                const previousEventValue = this.morphokinetics[index - 1].value
                return (previousEventValue / this.slideIncubationLength) * 100
            })
        },
        widthValues() {
            return this.morphokinetics.map((mk, index) => {
                const start = index === 0 ? 0 : this.morphokinetics[index - 1].value

                return ((mk.value - start) / this.slideIncubationLength) * 100
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.well-graphical-events-bar {
    width: 100%;
    height: 0.2rem;
    background-color: rgba(255, 255, 255, 0.5);
    position: relative;
    pointer-events: none;

    .graphical-event-tick {
        height: 100%;
        position: absolute;
        bottom: 0;
    }
}
</style>
